import { ShieldOff } from 'lucide-react';
import { Card } from '@/components/ui/primitives';

export function NoAccessPage() {
  return (
    <div className="flex min-h-[calc(100dvh-4rem)] items-center justify-center px-4 py-10">
      <Card className="w-full max-w-lg px-8 py-10 text-center">
        <div className="mx-auto flex size-14 items-center justify-center rounded-full border border-[var(--color-hairline)] bg-[var(--color-surface-elevated)]">
          <ShieldOff className="size-6 text-[var(--color-muted)]" aria-hidden />
        </div>
        <h1 className="mt-5 text-xl font-bold tracking-tight text-[var(--color-ink)] sm:text-2xl">
          Sem acesso
        </h1>
        <p className="mx-auto mt-2 max-w-sm text-sm text-[var(--color-body)]">
          Sua conta está ativa, mas nenhum módulo foi liberado ainda. Peça ao owner para conceder
          acesso.
        </p>
      </Card>
    </div>
  );
}
